import React, { useState } from 'react';
import { Spinner, MessageBar, MessageBarType, Link } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import CustomDashboardTasksTable from '../Components/CustomDashboardTasksTable';
import DeleteModal from '../../../Util/DeleteModal';
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../Util/ErrorComponent';
import SuccessComponent from '../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedTask, setSelectedTask] = useState(undefined);
    const [selectedSlug, setSelectedSlug] = useState('');
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data, loading }, refetch] = useAxios('/resources/custom-dashboard-tasks');

    if (loading) return <Spinner className="absolute-center" label="Loading Custom Tasks..." />;

    const tasks = data?.tasks || [];

    return (
        <>
            <MessageBar
                messageBarType={MessageBarType.info}
                isMultiline={true}
                styles={{ root: { marginBottom: 16 } }}
            >
                <strong>Custom Dashboard Tasks</strong> allows you to create data-driven dashboard tasks without writing code.
                <ul style={{ margin: '8px 0 0 0', paddingLeft: 20 }}>
                    <li><strong>Targeting:</strong> Assign tasks to specific cobrands, cobrand tags, or units within a cobrand</li>
                    <li><strong>Completion Check - Checklist:</strong> Mark complete when a user finishes a specific checklist</li>
                    <li><strong>Completion Check - Interaction:</strong> Mark complete when a user has a specific interaction type (e.g., ViewArticle, CompleteCourse, CreateBudget)</li>
                </ul>
                <span style={{ display: 'block', marginTop: 8, fontStyle: 'italic' }}>
                    Need more complex logic (e.g., date-based rules, multi-step conditions, external API checks)? Contact development for a custom coded solution.
                </span>
            </MessageBar>
            <SuccessComponent
                successMessage="Custom Task Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <CustomDashboardTasksTable
                tasks={tasks}
                setSelectedTask={setSelectedTask}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(id, slug) => {
                    setSelectedTask({ customTaskId: id });
                    setSelectedSlug(slug);
                    toggleDeleteModal();
                }}
                refetch={refetch}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`resources/custom-dashboard-tasks/${selectedTask?.customTaskId}`}
                resourceName={selectedSlug}
                resourceType="custom dashboard task"
                confirmationValue={selectedSlug || undefined}
            />
        </>
    );
};

export default DefaultPage;
